export default {
    CLIENT_REVIEW: 'clientReview',
    SIGNATORIES: 'signatories',
    INCORPORATION_PACK: 'incorporationPack'
};